//@ts-nocheck
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { StarRatingBar } from "../../../Constant";
import { STAR_RATING } from "../../../Data/Bonus Ui/Rating";
import Rating from "react-rating";
import { P } from "../../../AbstractElements";
import { useState } from "react";

const StarRating = () => {
  const [rating, setRating] = useState(3.5);

  const handleRatingChange = (newRating) => {
    setRating(newRating);
  };

  return (
    <Col xl="4" md="6">
      <Card>
        <CommonCardHeader title={StarRatingBar} span={STAR_RATING} />
        <CardBody>
          <Rating initialRating={rating} emptySymbol="fa fa-star-o fa-2x" fullSymbol="fa fa-star fa-2x" fractions={2} onClick={handleRatingChange}/>
          <P className="current-rating">Selected Rating: {rating}</P>
        </CardBody>
      </Card>
    </Col>
  );
};

export default StarRating;
